import React, { useMemo } from "react";
import CustomModal from "../CustomModal";
import CustomInput from "../CustomInput";
import CustomButton from "../CustomButton";
import { SelectBox } from "../CustomSelect";

export const ListingFilterModal = ({
  show,
  close,
  amenitiesList = [],
  roomList = [],
  filters = {},
  onChange,
  onSubmit,
}) => {
  const roomCountOptions = useMemo(
    () =>
      ["1", "2", "3", "4", "5"].map((n) => ({
        id: n,
        name: n,
      })),
    []
  );

  const petsOptions = useMemo(
    () => [
      { id: "1", name: "Yes" },
      { id: "0", name: "No" },
    ],
    []
  );

  const handleFieldChange = (name, value) => {
    onChange?.({ ...filters, [name]: value });
  };

  const handleAmenityToggle = (amenityId) => {
    const current = Array.isArray(filters.amenities) ? filters.amenities : [];
    const next = current.includes(amenityId)
      ? current.filter((a) => a !== amenityId)
      : [...current, amenityId];
    handleFieldChange("amenities", next);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit?.(filters);
  };

  return (
    <CustomModal
      size="lg"
      show={show}
      close={close}
      heading="Filter"
      handleSubmit={handleSubmit}
    >
      <div className="row">
        <div className="col-md-4 mb-4">
          <SelectBox
            selectClass="mainInput"
            name="place_id"
            placeholder="Room Type"
            option={roomList}
            value={filters.place_id || ""}
            onChange={(e) => handleFieldChange("place_id", e.target.value)}
          />
        </div>

        <div className="col-md-4 mb-4">
          <SelectBox
            selectClass="mainInput"
            name="rooms"
            placeholder="Rooms"
            option={roomCountOptions}
            value={filters.rooms || ""}
            onChange={(e) => handleFieldChange("rooms", e.target.value)}
          />
        </div>

        <div className="col-md-4 mb-4">
          <SelectBox
            selectClass="mainInput"
            name="pets"
            placeholder="Pets"
            option={petsOptions}
            value={filters.pets || ""}
            onChange={(e) => handleFieldChange("pets", e.target.value)}
          />
        </div>

        <div className="col-md-4 mb-4">
          <CustomInput
            type="number"
            placeholder="Min Price"
            name="min_price"
            labelClass="mainLabel"
            inputClass="mainInput"
            value={filters.min_price || ""}
            onChange={(e) => handleFieldChange("min_price", e.target.value)}
          />
        </div>

        <div className="col-md-4 mb-4">
          <CustomInput
            type="number"
            placeholder="Max Price"
            name="max_price"
            labelClass="mainLabel"
            inputClass="mainInput"
            value={filters.max_price || ""}
            onChange={(e) => handleFieldChange("max_price", e.target.value)}
          />
        </div>

        <div className="col-md-12">
          <div className="row">
            {Array.isArray(amenitiesList) &&
              amenitiesList.map((item, index) => {
                const amenityId = item?.id ?? '';
                const amenityName = item?.amenity_name || "";
                const selected = Array.isArray(filters.amenities)
                  ? filters.amenities.includes(amenityId)
                  : false;
                return (
                  <div className="mb-3 col-md-4 mb-md-1" key={item?.id || index}>
                    <input
                      type="checkbox"
                      name="amenities"
                      value={amenityId}
                      id={`amen-${item?.id || index}`}
                      checked={selected}
                      onChange={() => handleAmenityToggle(amenityId)}
                    />
                    <label htmlFor={`amen-${item?.id || index}`} className="mx-2 w-auto">
                      {amenityName}
                    </label>
                  </div>
                );
              })}
          </div>
        </div>
      </div>

      <div className="col-md-12">
        <CustomButton
          variant="primaryButton"
          text="Search"
          className="mt-4"
          type="submit"
        />
      </div>
    </CustomModal>
  );
};
